import React, { FunctionComponent, useState, useEffect } from 'react';
import { RecordingModel } from 'features/recordings/RecordingModel';
import { Card } from 'components/Card';
import { useSelector } from 'react-redux';
import { RootState } from 'rootReducer';
import { Loader } from 'components/Loader';
import { useSubdomain } from 'hooks/useSubdomain';
import { fetchRecordings } from 'features/recordings/recordingsSlice';
import { useDispatch } from 'react-redux';
import { useInView } from 'react-intersection-observer';

export interface InfiniteScrollRecordingsProps {
  recordings: RecordingModel[];
  itemsPerPage: number;
}

export const InfiniteScrollRecordings: FunctionComponent<
  InfiniteScrollRecordingsProps
> = ({ recordings, itemsPerPage }) => {
  const [currentItems, setCurrentItems] = useState<RecordingModel[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemOffset, setItemOffset] = useState(0);
  const loading = useSelector((state: RootState) => state.recordings.isLoading);
  const pageCount = useSelector(
    (state: RootState) => state.recordings.pageCount
  );
  const subdomain = useSubdomain();
  const dispatch = useDispatch();
  const { ref, inView } = useInView({
    threshold: 0
  });

  useEffect(
    function setCurrentRecordings() {
      const endOffset = itemOffset + itemsPerPage;
      console.log(`Loading recordings from ${itemOffset} to ${endOffset}`);
      setCurrentItems(recordings);
    },
    [itemOffset, itemsPerPage, recordings]
  );

  useEffect(
    function fetchRercordingsOnScroll() {
      if (inView && currentPage <= pageCount) {
        dispatch(fetchRecordings(subdomain, currentPage + 1));
        const newOffset = currentPage * itemsPerPage;
        setItemOffset(newOffset);
        setCurrentPage((prevState) => prevState + 1);
      }
    },
    [inView, currentPage, dispatch, itemsPerPage, pageCount, subdomain]
  );

  return (
    <div className="container--wide">
      <h1>Recordings</h1>
      <ul className="list--reset grid">
        {currentItems.map((recording, index) => {
          const lastElement = index === currentItems.length - 1;
          return (
            <li
              className="col-xss-12 col-xs-6"
              key={recording.id}
              ref={lastElement ? ref : null}
            >
              <Card
                id={recording.id}
                url={`/recordings/${recording.id}`}
                title={`${recording.title}`}
                artworkKey={recording.artworkKey}
                artworkMode={'recording'}
                type={'recording'}
              />
            </li>
          );
        })}
      </ul>
      {loading && (
        <div className="text--center mar-t mar-b">
          <Loader />
        </div>
      )}
    </div>
  );
};
